import { useState } from 'react';
import { testimonials } from '@/mocks/articles';

export default function TestimonialSection() {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((c) => (c === 0 ? testimonials.length - 1 : c - 1));
  const next = () => setCurrent((c) => (c === testimonials.length - 1 ? 0 : c + 1));

  const t = testimonials[current];

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <p className="text-base md:text-lg font-heading italic text-foreground-400 mb-8">
            (What Our Community Says)
          </p>

          <div className="inline-flex items-center gap-2 px-3 py-1.5 mb-8 bg-foreground-950 text-background-50 rounded-full text-sm font-semibold">
            <i className="ri-star-fill text-accent-400 w-4 h-4 flex items-center justify-center"></i>
            <span>4.9 / 5.0</span>
          </div>

          <blockquote className="text-lg md:text-xl text-foreground-600 leading-relaxed mb-8 font-body italic">
            &ldquo;{t.quote}&rdquo;
          </blockquote>

          <div className="flex items-center justify-center gap-3 mb-8">
            <div className="w-12 h-12 rounded-full overflow-hidden bg-background-200 shrink-0">
              <img
                src={t.avatar}
                alt={`${t.name} testimonial`}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="text-left">
              <div className="text-sm font-semibold text-foreground-900">{t.name}</div>
              <div className="text-xs text-foreground-500">{t.role}</div>
            </div>
          </div>

          <div className="flex items-center justify-center gap-2">
            <button
              onClick={prev}
              className="w-10 h-10 rounded-full border border-background-300/60 flex items-center justify-center hover:border-foreground-300 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center text-foreground-600"></i>
            </button>
            <button
              onClick={next}
              className="w-10 h-10 rounded-full bg-foreground-950 flex items-center justify-center hover:bg-foreground-800 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center text-background-50"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}